import { IUserListSelectorDialogCondition, instanceOfIUserListSelectorDialogCondition } from "./IUserListSelectorDialogCondition";

export interface IMultiUserListSelectorDialogCondition extends IUserListSelectorDialogCondition {
  isMultiSelectable: boolean;
  isMultiSingleSwitchable: boolean;
}

export function instanceOfIMultiUserListSelectorDialogCondition(instance: any): instance is IMultiUserListSelectorDialogCondition {
  return instance
  && (instance.isMultiSelectable !== undefined)
  && (instance.isMultiSingleSwitchable !== undefined)
  && instanceOfIUserListSelectorDialogCondition(instance);
}

